import React from 'react';
import { GoogleMap } from '@react-google-maps/api';
import { useRobinhoodGoogleMaps } from '../hooks/useRobinhoodGoogleMaps';
import { getGoogleMapsKeyIssue } from '../api/mapsConfig';
import { isGoogleMapsReady } from '../utils/mapCoordinates';

/**
 * Renders GoogleMap only when GoogleMapsProvider has loaded the script (GOVOPS-1105).
 * Never use useJsApiLoader or LoadScript in page components — prevents duplicate loader crashes.
 */
const SafeGoogleMap = ({ children, onLoad, ...mapProps }) => {
  const { isLoaded, loadError } = useRobinhoodGoogleMaps();
  const keyIssue = getGoogleMapsKeyIssue();

  if (keyIssue || loadError || !isLoaded || !isGoogleMapsReady()) {
    return null;
  }

  const handleLoad = (mapInstance) => {
    if (!isGoogleMapsReady()) return;
    if (typeof onLoad === 'function') onLoad(mapInstance);
  };

  return (
    <GoogleMap {...mapProps} onLoad={handleLoad}>
      {isGoogleMapsReady() ? children : null}
    </GoogleMap>
  );
};

export default SafeGoogleMap;
